import React, { useState, useEffect } from "react";
import equal from "fast-deep-equal/es6";
import { makeStyles } from "tss-react/mui";
import { ReferrerType } from "../../../contract/pam.js";
import { useReduxForm } from "../../../redux-folder/form/hooks.js";
import { playerReferralActions } from "../actions.js";
import { UserReferralInfoFormContent } from "./ReferrerInfoFormContent.js";
const useClasses = makeStyles()((_theme) => ({
  referralInfoForm: {
    width: "100%",
    display: "flex",
    alignItems: "center"
  }
}));
const UserReferralInfoForm = ({
  userId,
  affiliate,
  referral,
  isAgentReferrer,
  aal_groups,
  availableTypes,
  referralInfoEditMode,
  disabled
}) => {
  const { classes } = useClasses();
  const getUserReferral = () => referral?.referrer_id ? {
    referrer_id: referral?.referrer_id,
    referee_uid: userId,
    referrer_type: ReferrerType.P2P,
    id: referral?.id
  } : affiliate?.btag ? {
    referrer_id: affiliate?.btag,
    referee_uid: userId,
    referrer_type: ReferrerType.Affiliate,
    id: referral?.id
  } : {};
  const [errorState, setErrorState] = useState(null);
  const [userReferral, setUserReferral] = useState(getUserReferral());
  useEffect(() => {
    setUserReferral(getUserReferral());
  }, [affiliate?.btag, referral?.referrer_id]);
  const isReferralEmpty = userReferral === null || userReferral === void 0 || equal(userReferral, {});
  const { control, state, submit, cancel, handleSubmit, trigger } = useReduxForm({
    initialModel: userReferral,
    asyncAction: playerReferralActions.changeReferrerInfo,
    map: (m) => {
      const isRemove = !isReferralEmpty && !m?.referrer_id;
      const isUpdate = !isReferralEmpty && m?.referrer_id;
      const mode = isRemove ? "remove" : isUpdate ? "update" : "add";
      return {
        mode,
        referral: {
          referrer_id: m?.referrer_id,
          referee_uid: userId,
          referrer_type: m?.referrer_id ? m?.referrer_type : null,
          id: userReferral?.id
        }
      };
    }
  });
  return /* @__PURE__ */ React.createElement("form", { onSubmit: handleSubmit(submit), className: classes.referralInfoForm }, /* @__PURE__ */ React.createElement(
    UserReferralInfoFormContent,
    {
      control,
      trigger,
      mode: state.isProgress ? "InProgress" : "Read",
      disabled: disabled || referralInfoEditMode === "read-only",
      onSave: () => handleSubmit(submit),
      onCancel: cancel,
      referral: userReferral,
      userId,
      isAgentReferrer,
      referrerInfoMode: referralInfoEditMode,
      formErrorState: errorState,
      onFormErrorStateChange: setErrorState,
      disabledSubmitButton: !!errorState,
      aal_groups,
      availableTypes
    }
  ));
};
export {
  UserReferralInfoForm
};
//# sourceMappingURL=ReferrerInfoForm.js.map
